import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function map() {

  window.addEventListener('DOMContentLoaded', function () {
    gsap.config({ nullTargetWarn: false })

    console.log("表示テスト");
    // アイコン表示
    const fadeInElements = document.querySelectorAll(".p-store-map__icon");
    fadeInElements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          autoAlpha: 0,
          y: 10,
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: .5,
          ease: "power4.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 90%", // スクロール開始位置を指定
            toggleActions: 'play none none reverse',
            stagger: .5,
            // markers: true,
          },
        }
      );
    });

    // ボタンのクリックイベントとマウスオーバーイベントを取得
    const clickIcons = document.querySelectorAll(".p-store-map__icon");
    const boxes = document.querySelectorAll(".p-store-map__box");

    // イベント処理を共通化した関数
    function handleEvent(icon, index) {
      // すべてのボックスを非表示に設定
      boxes.forEach((box) => {
        gsap.to(box, {
          autoAlpha: 0,
          transformOrigin: "left bottom",
          duration: 0.5,
        });
      });

      // 対応するボックスのみを表示
      const currentBox = document.querySelector(`.p-store-map__box${('0' + (index + 1)).slice(-2)}`);
      gsap.to(currentBox, {
        autoAlpha: 1,
        transformOrigin: "left bottom",
        duration: 0.5,
      });

      // 'is-active' クラスをすべてのアイコンから削除し、現在のアイコンにのみ追加
      clickIcons.forEach(icon => icon.classList.remove('is-active'));
      icon.classList.add('is-active');
    }

    clickIcons.forEach((icon, index) => {
      // クリックイベントリスナー
      icon.addEventListener("click", function () {
        handleEvent(icon, index);
      });

      // マウスオーバーイベントリスナー
      icon.addEventListener("mouseover", function () {
        handleEvent(icon, index);
      });
    });
  })
}
